import { BulkFileUpload, type BulkUploadResponse } from './BulkFileUpload';

interface UploadSectionProps {
  upload: {
    label: string;
    buttonText: string;
    helperText: string;
    accept: string;
  };
  handleBulkUpload: (files: File[]) => Promise<BulkUploadResponse>;
  handleBulkUploadComplete: (response: BulkUploadResponse) => void;
  handleBulkFileSelect: (files: File[] | null) => void;
  recordCount: number;
  setRecordCount: (count: number | null) => void;
  handleReset: () => void;
  error: string | null;
  maxFiles?: number;
  maxSizeMB?: number;
}

export function UploadSection({
  upload,
  handleBulkUpload,
  handleBulkUploadComplete,
  handleBulkFileSelect,
  recordCount,
  setRecordCount,
  handleReset,
  error,
  maxFiles = 20,
  maxSizeMB = 100,
}: UploadSectionProps) {
  return (
    <div className="space-y-2 px-1 pt-4">
      <h2 className="font-medium text-sm">{upload.label}</h2>
      <BulkFileUpload
        instructions={upload.buttonText}
        accept={upload.accept}
        uploadButtonText={upload.buttonText}
        onUpload={handleBulkUpload}
        onUploadComplete={handleBulkUploadComplete}
        onFileSelect={handleBulkFileSelect}
        recordCount={recordCount}
        setRecordCount={setRecordCount}
        onReset={handleReset}
        error={error}
        maxFiles={maxFiles}
        maxSizeMB={maxSizeMB}
      />
      <p className="text-base text-muted-foreground text-xs">
        {upload.helperText}
      </p>
    </div>
  );
}
